import React from 'react';

import Button from '../../../../library/button/button';
import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';

import './saved-fitment-message.scss';

interface SavedFitmentMessageProps {
  isLoggedIn: boolean;
  onSignInClick: () => void;
}

function SavedFitmentMessage(props: SavedFitmentMessageProps) {
  const { isLoggedIn, onSignInClick } = props;
  return (
    <Typography styleName="message">
      {isLoggedIn ? (
        <>
          Go to <Link to="/my-account/vehicles">My Account</Link> to save your
          ride under My Vehicles!
        </>
      ) : (
        <>
          <Button onClick={onSignInClick} size="regular">
            Create Account/Sign In
          </Button>
          &nbsp;to save your ride under My Vehicles in your account!
        </>
      )}
    </Typography>
  );
}

export default SavedFitmentMessage;
